export const langMap = {
    "BackButton": {
      "EN": "Back to homepage",
      "IT": "Torna alla homepage",
      "ES": "Volver a la página de inicio",
      "FR": "retour à la page d'accueil",
      "DE": "Zurück zur Startseite"
    },
    "Title": {
      "EN": "LIGHTCAST EUROPEAN INSIGHTS TERMS OF USE",
      "IT": "LIGHTCAST EUROPEAN INSIGHTS TERMINI DI UTILIZZO",
      "ES": "CONDICIONES DE USO DE LIGHTCAST EUROPEAN INSIGHTS",
      "FR": "CONDITIONS D'UTILISATION DE LIGHTCAST EUROPEAN INSIGHTS",
      "DE": "NUTZUNGSBEDINGUNGEN VON LIGHTCAST EUROPEAN INSIGHTS"
    },
    "Intro1": {
      "EN": "By accessing the Lightcast European Insights dataset and API (“",
      "IT": "Accedendo al dataset e all'API Lightcast European Insights (\"",
      "ES": "Al acceder al conjunto de datos y la API de Lightcast European Insights (en adelante, el «",
      "FR": "En accédant à l'ensemble de données et à l'API Lightcast European Insights (ci-après dénommés «",
      "DE": "Durch den Zugriff auf den Lightcast European Insights-Datensatz und die zugehörige API („"
    },
    "Intro2": {
      "EN": "Dataset",
      "IT": "Dataset",
      "ES": "Conjunto de datos",
      "FR": "Ensemble de données",
      "DE": "Datensatz"
    },
    "Intro3": {
      "EN": "” and, together with the API, the “",
      "IT": "\" e, insieme all'API, i \"",
      "ES": "» y, junto con la API, los «",
      "FR": "» et, conjointement avec l'API, «",
      "DE": "“ und zusammen mit der API die „"
    },
    "Intro4": {
      "EN": "Lightcast Materials",
      "IT": "Lightcast Materials",
      "ES": "Lightcast Materials",
      "FR": "Lightcast Materials",
      "DE": "Lightcast Materials"
    },
    "Intro5": {
      "EN": "”), you agree to the following terms (these “",
      "IT": "\"), l'utente accetta i seguenti termini (i \"",
      "ES": "»), usted acepta los siguientes términos (en adelante, los «",
      "FR": "»), vous acceptez les conditions suivantes (ci-après dénommées «",
      "DE": "“) erklären Sie sich mit den folgenden Bedingungen (diese „"
    },
    "Intro6": {
      "EN": "Terms",
      "IT": "Termini",
      "ES": "Términos",
      "FR": "Conditions",
      "DE": "Bedingungen"
    },
    "Intro7": {
      "EN": "”) between you and Economic Modeling, LLC (“Lightcast”). Lightcast will not revoke this license, or your access to the API and Dataset, provided you abide by these terms. As used herein, the term “you” or “your” refers to an individual, representing yourself or, if applicable, acting as legal representative for a group, business entity or corporation",
      "IT": "\") tra l'utente e Economic Modeling, LLC (\"Lightcast\"). Lightcast non revocherà la presente licenza, né l'accesso dell'utente all'API e al Dataset, a condizione che l'utente rispetti i presenti termini. Nel presente documento, il termine \"utente\" o \"tuo\" si riferisce a una persona fisica, che rappresenta se stessa o, se del caso, che agisce in qualità di rappresentante legale di un gruppo, un'entità commerciale o una società.",
      "ES": "») entre usted y Economic Modeling, LLC (en adelante, «Lightcast»). Lightcast no revocará esta licencia ni su acceso a la API y al Conjunto de datos, siempre que usted cumpla con estos términos. En el presente documento, el término «usted» o ​​«su» se refiere a una persona física que se representa a sí misma o, en su caso, que actúa como representante legal de un grupo, entidad comercial o corporación.",
      "FR": "») conclues entre vous et Economic Modeling, LLC (« Lightcast »). Lightcast ne révoquera pas cette licence ni votre accès à l'API et à l'Ensemble de données tant que vous respecterez les présentes Conditions. Dans les présentes, les termes « vous » ou « votre » désignent une personne physique, agissant pour son propre compte ou, le cas échéant, en qualité de représentant légal d'un groupe, d'une entité commerciale ou d'une société.",
      "DE": "“) zwischen Ihnen und Economic Modeling, LLC („Lightcast“) einverstanden. Lightcast wird diese Lizenz oder Ihren Zugriff auf die API und den Datensatz nicht widerrufen, sofern Sie diese Bedingungen einhalten. In diesen Bedingungen bezieht sich der Begriff „Sie“ oder „Ihr/Ihre“ auf eine natürliche Person, die in eigener Sache handelt oder gegebenenfalls als gesetzlicher Vertreter einer Gruppe, eines Unternehmens oder einer Gesellschaft auftritt."
    },
    "LicenseTitle": {
      "EN": "License",
      "IT": "Licenza",
      "ES": "Licencia",
      "FR": "Licence",
      "DE": "Lizenz"
    },
    "LicenseText": {
      "EN": "You acknowledge that as between you and Lightcast, Lightcast owns all right, title, and interest in and to the Lightcast Materials. Subject to your compliance with these Terms, Lightcast grants you a limited, personal, royalty-free, fully paid-up, perpetual, non-transferable, non-sublicensable, and worldwide right and license to use the Dataset solely as provided in these Terms.",
      "IT": "L'utente riconosce che, tra l'utente e Lightcast, Lightcast detiene tutti i diritti, titoli e interessi relativi ai Materiali Lightcast. A condizione che l'utente rispetti i presenti Termini, Lightcast concede all'utente un diritto e una licenza limitati, personali, esenti da royalty, interamente pagati, perpetui, non trasferibili, non sublicenziabili e validi in tutto il mondo per utilizzare il Dataset esclusivamente secondo quanto previsto nei presenti Termini.",
      "ES": "Usted reconoce que, entre usted y Lightcast, Lightcast posee todos los derechos, títulos e intereses sobre los Materiales de Lightcast. Sujeto a su cumplimiento de estos Términos, Lightcast le otorga una licencia y un derecho limitados, personales, libres de regalías, totalmente pagados, perpetuos, intransferibles, no sublicenciables y de alcance mundial para usar el Conjunto de Datos únicamente según lo estipulado en estos Términos.",
      "FR": "Vous reconnaissez qu'entre vous et Lightcast, Lightcast détient tous les droits, titres et intérêts relatifs aux Documents Lightcast. Sous réserve du respect des présentes Conditions, Lightcast vous concède une licence limitée, personnelle, gratuite, entièrement payée, perpétuelle, non transférable, non sous-licenciable et mondiale vous autorisant à utiliser l'Ensemble de données uniquement conformément aux présentes Conditions.",
      "DE": "Sie erkennen an, dass Lightcast im Verhältnis zwischen Ihnen und Lightcast alle Rechte, Titel und Ansprüche an den Lightcast-Materialien besitzt. Vorbehaltlich Ihrer Einhaltung dieser Bedingungen gewährt Ihnen Lightcast ein beschränktes, persönliches, lizenzgebührenfreies, vollständig bezahltes, unbefristetes, nicht übertragbares, nicht unterlizenzierbares und weltweites Recht und die Lizenz zur Nutzung des Datensatzes ausschließlich gemäß diesen Bedingungen."
    },
    "AbleTitle1": {
      "EN": "What You ",
      "IT": "Cosa Tu ",
      "ES": "Lo Que ",
      "FR": "Ce Que Vous ",
      "DE": "Was Sie "
    },
    "AbleTitle2": {
      "EN": "Can",
      "IT": "Puoi",
      "ES": "Puedes",
      "FR": "Pouvez",
      "DE": "Tun Können"
    },
    "AbleTitle3": {
      "EN": "Do",
      "IT": "Fare",
      "ES": "Hacer",
      "FR": "Faire",
      "DE": ""
    },
    "AbleTextSection1": {
      "EN": "You may copy and redistribute all or part of the Dataset in any medium or format, and for any purpose – excluding commercial or for-profit purposes.",
      "IT": "È consentito copiare e ridistribuire in tutto o in parte il Dataset in qualsiasi formato o supporto e per qualsiasi scopo, ad eccezione di scopi commerciali o a scopo di lucro.",
      "ES": "Usted puede copiar y redistribuir la totalidad o parte del conjunto de datos en cualquier medio o formato, y para cualquier propósito, excluyendo fines comerciales o lucrativos.",
      "FR": "Vous pouvez copier et redistribuer tout ou partie de l'ensemble de données sur tout support ou dans tout format, et à toute fin – à l'exclusion des fins commerciales ou lucratives.",
      "DE": "Sie dürfen den gesamten Datensatz oder Teile davon in jedem Medium oder Format und für jeden Zweck kopieren und weiterverbreiten – ausgenommen sind kommerzielle oder gewinnorientierte Zwecke."
    },
    "AbleTextSection2": {
      "EN": "You may transform and build upon the Dataset for any purpose – excluding commercial or for-profit purposes.",
      "IT": "È possibile trasformare e utilizzare il Dataset per qualsiasi scopo, ad eccezione di scopi commerciali o a scopo di lucro.",
      "ES": "Usted puede transformar y utilizar el conjunto de datos como base para cualquier propósito, excluyendo fines comerciales o lucrativos.",
      "FR": "Vous pouvez transformer et enrichir l'ensemble de données à toutes fins utiles, à l'exclusion des fins commerciales ou lucratives.",
      "DE": "Sie dürfen den Datensatz für jeden Zweck verändern und darauf aufbauen – ausgenommen sind kommerzielle oder gewinnorientierte Zwecke."
    },
    "AbleTextSection3": {
      "EN": "Commercial or for-profit purposes may be permitted provided the user contacts Lightcast and enters into a no-cost contract setting forth the agreed intended use and any intended transformations and builds (derivatives) upon the Dataset. Lightcast reserves the right to deny any use of the Lightcast Materials at its sole discretion.",
      "IT": "L'utilizzo a fini commerciali o a scopo di lucro può essere consentito a condizione che l'utente contatti Lightcast e stipuli un contratto gratuito che specifichi l'uso previsto concordato e le eventuali trasformazioni e creazioni (derivate) che si intendono realizzare a partire dal Dataset. Lightcast si riserva il diritto di negare qualsiasi utilizzo dei Materiali Lightcast a sua esclusiva discrezione.",
      "ES": "Se permite el uso con fines comerciales o lucrativos siempre que el usuario contacte con Lightcast y suscriba un contrato gratuito en el que se especifique el uso previsto y las transformaciones y creaciones (derivados) que se pretendan realizar sobre el conjunto de datos. Lightcast se reserva el derecho de denegar cualquier uso de los materiales de Lightcast a su entera discreción.",
      "FR": "L’utilisation à des fins commerciales ou lucratives est autorisée à condition que l’utilisateur contacte Lightcast et conclue un contrat gratuit précisant l’utilisation prévue ainsi que les transformations et créations dérivées envisagées à partir des données. Lightcast se réserve le droit de refuser toute utilisation des documents Lightcast à son entière discrétion.",
      "DE": "Die kommerzielle oder gewinnorientierte Nutzung ist unter bestimmten Voraussetzungen zulässig, sofern der Nutzer Lightcast kontaktiert und einen kostenlosen Vertrag abschließt, der die vereinbarte Nutzung sowie alle beabsichtigten Bearbeitungen und Weiterentwicklungen (Derivate) des Datensatzes festlegt. Lightcast behält sich das Recht vor, die Nutzung der Lightcast-Materialien nach eigenem Ermessen zu untersagen."
    },
    "AbleTextSection4_1": {
      "EN": "(each, a “",
      "IT": "(ciascuno, un “",
      "ES": "(cada uno, un \"",
      "FR": "(chacune, une «",
      "DE": "(jeweils eine „"
    },
    "AbleTextSection4_2": {
      "EN": "Permitted Use",
      "IT": "Uso consentito",
      "ES": "uso permitido",
      "FR": "Utilisation autorisée",
      "DE": "zulässige Nutzung"
    },
    "AbleTextSection4_3": {
      "EN": "”)",
      "IT": "”)",
      "ES": "\")",
      "FR": "»)",
      "DE": "“)"
    },
    "UnableTitle1": {
      "EN": "What You ",
      "IT": "Cosa Tu ",
      "ES": "Lo Que ",
      "FR": "Ce Que Vous ",
      "DE": "Was Sie "
    },
    "UnableTitle2": {
      "EN": "Can’t",
      "IT": "Non Puoi",
      "ES": "No Puedes",
      "FR": "Ne Pouvez Pas",
      "DE": "Nicht Tun Können"
    },
    "UnableTitle3": {
      "EN": " Do",
      "IT": "Fare",
      "ES": "Hacer",
      "FR": "Faire",
      "DE": ""
    },
    "UnableSection1": {
      "EN": "You can’t use the Lightcast Materials except as expressly stated in Section 2.",
      "IT": "Non è possibile utilizzare i Lightcast Materials se non nei modi espressamente indicati nella Sezione 2.",
      "ES": "No se pueden utilizar los materiales de Lightcast excepto en los casos expresamente indicados en la Sección 2.",
      "FR": "Vous ne pouvez utiliser les matériaux Lightcast que dans les conditions expressément prévues à la section 2.",
      "DE": "Die Verwendung der Lightcast-Materialien ist nur in den in Abschnitt 2 ausdrücklich genannten Fällen gestattet."
    },
    "UnableSection2": {
      "EN": "You can’t redistribute all or any part of the Dataset as your own work",
      "IT": "Non è consentito ridistribuire il Dataset, in tutto o in parte, come opera propria.",
      "ES": "No puedes redistribuir la totalidad ni ninguna parte del conjunto de datos como si fuera tu propio trabajo.",
      "FR": "Vous ne pouvez pas redistribuer tout ou partie du jeu de données comme étant votre propre travail.",
      "DE": "Sie dürfen den Datensatz weder ganz noch teilweise als Ihr eigenes Werk weiterverbreiten."
    },
    "UnableSection3_1": {
      "EN": "(each, a “",
      "IT": "(ciascuno, un “",
      "ES": "(cada uno, un \"",
      "FR": "(chacune, une «",
      "DE": "(jeweils eine „"
    },
    "UnableSection3_2": {
      "EN": "Permitted Use",
      "IT": "Uso consentito",
      "ES": "uso permitido",
      "FR": "Utilisation autorisée",
      "DE": "zulässige Nutzung"
    },
    "UnableSection3_3": {
      "EN": "”)",
      "IT": "”)",
      "ES": "\")",
      "FR": "»)",
      "DE": "“)"
    }
}